import { initializePublicAnchors } from "@/lib/publicAnchors";

// Public pages keep their content and links in server-rendered HTML.
export function initializePublicPage(root: Document = document) {
  initializePublicAnchors(root);
  const context = root.getElementById("public-demo-context");
  if (context) {
    void import("@/lib/publicDemos").then(({ mountPublicDemos }) => mountPublicDemos(root, JSON.parse(context.textContent ?? "{}"))).catch(() => { /* Static content and contact links remain usable. */ });
  }
  // 一覧のページ送りはサーバー側の `?page=N` リンクのみ (2026-09-18)。以前の「次ページを JS で追記する」
  // 拡張はクローラと利用者で見える内容が変わるため外した。
}
